export default {
  form: {
    shipping_company_name: {
      label: 'Entreprise',
      placeholder: "Saisir le nom de l'entreprise",
    },
    shipping_phone_number: {
      label: 'Numéro de téléphone',
      placeholder: 'Saisir le numéro de téléphone',
    },
    shipping_salutation: {
      label: 'Civilité',
      options: {
        mr: 'M.',
        mrs: 'Mme',
      },
    },
    shipping_first_name: {
      label: 'Prénom',
      placeholder: 'Saisir le prénom',
    },
    shipping_last_name: {
      label: 'Nom',
      placeholder: 'Saisir le nom',
    },
  },
  buttons: {
    back: 'Retour',
    next: 'Suivant',
  },
};
